import { AxiosError } from 'axios';
import axiosInterseptor from '../../utils/axiosInterseptor';
import { adaptPhotos } from '../../utils/catalogUtils';

export default class MessageData {
  static async getMessageDataСhat({
    id,
    offset,
    signal,
  }: {
    id: string;
    offset?: number;
    signal?: AbortSignal;
  }) {
    try {
      let params = '';
      if (offset) {
        params = `?offset=${offset}`;
      }
      const response = await axiosInterseptor.get(`chats/chat/${id}${params}`, {
        signal,
      });
      const { data } = response;
      data.photos = adaptPhotos(
        data.photos.photos,
        { photos_url: data.photos.url, photos_res: data.photos.res },
        data.product_id,
      );
      return data;
    } catch (error) {
      if (error instanceof AxiosError) {
        const errorMessage = error.response?.data || error.message;
        return {
          error: typeof errorMessage === 'string' ? errorMessage : 'Unknown error',
        };
      }
      return { error: 'Network or unknown error' };
    }
  }

  static async getCreatedСhat(product_id: string) {
    try {
      const response = await axiosInterseptor.get(`chats/chat?product_id=${product_id}`);
      const { data } = response;
      data.photos = adaptPhotos(
        data.photos.photos,
        { photos_url: data.photos.url, photos_res: data.photos.res },
        data.product_id,
      );
      return data;
    } catch (error) {
      if (error instanceof AxiosError) {
        const errorMessage = error.response?.data || error.message;
        return {
          error: typeof errorMessage === 'string' ? errorMessage : 'Unknown error',
        };
      }
      return { error: 'Network or unknown error' };
    }
  }

  static async getMessageDataAllChats(page: number, signal: AbortSignal) {
    try {
      const response = await axiosInterseptor.get(`chats?mode=filter&page=${page}`, {
        signal,
      });
      const { data } = response;
      if (data.data && Array.isArray(data.data)) {
        data.data = data.data.map((item: any) => ({
          ...item,
          photos: adaptPhotos(item.photos, data.meta, item.product_id),
        }));
      }
      return data;
    } catch (error) {
      return error;
    }
  }

  static async postAddedMessage(chat_id: string, text: string, media?: any) {
    try {
      const response = await axiosInterseptor.post(
        `chats/chat/${chat_id}/message`,
        {
          text,
          media,
        },
        {
          headers: {
            'Cache-Control': 'no-cache',
          },
        },
      );
      const { data } = response;
      return data;
    } catch (error: any) {
      if (error?.response) {
        const errorMessage =
          typeof error.response.data === 'string'
            ? error.response.data
            : JSON.stringify(error.response.data);
        throw new Error(errorMessage);
      }
      throw new Error(`Не удалось отправить сообщени: ${error.message}`);
    }
  }

  static async postAddedMedia(file: File) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axiosInterseptor.post('/user/media', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Cache-Control': 'no-cache',
        },
      });

      const { data } = response;
      return data;
    } catch (error: any) {
      if (error?.response) {
        const errorMessage =
          typeof error.response.data === 'string'
            ? error.response.data
            : JSON.stringify(error.response.data);
        throw new Error(errorMessage);
      }
      throw new Error(`Не удалось загрузить файл: ${error.message}`);
    }
  }

  static async getNewMessages(id: string, last_id: number) {
    try {
      const response = await axiosInterseptor.get(`chats/chat/${id}/messages?last_id=${last_id}`);
      const { data } = response;
      return data;
    } catch (error) {
      if (error instanceof AxiosError) {
        const errorMessage = error.response?.data || error.message;
        return {
          error: typeof errorMessage === 'string' ? errorMessage : 'Unknown error',
        };
      }
      return { error: 'Network or unknown error' };
    }
  }
}
